import React from 'react';
import DataPlataformListPage from '../../Components/DataPlataformListPage';

const icons = {
    exercicio: <img src="/images/icons/calendar_search_black.svg" alt="Exercício" width={18} style={{ marginRight: 6 }} />,
    uf: <img src="/images/icons/point_on_map_black.svg" alt="UF" width={18} style={{ marginRight: 6 }} />,
    municipio: <img src="/images/icons/city_black.svg" alt="Município" width={18} style={{ marginRight: 6 }} />,
    tipo: <img src="/images/icons/filter_black.svg" alt="Tipo de Despesa" width={18} style={{ marginRight: 6 }} />,
    conta: <img src="/images/icons/magnifer_black.svg" alt="Conta" width={18} style={{ marginRight: 6 }} />,
    valor: <img src="/images/icons/dollar_minimalistic_black.svg" alt="Valor" width={18} style={{ marginRight: 6 }} />,
};

const columns = [
    { key: 'exercicio', label: 'Exercício', icon: icons.exercicio },
    { key: 'uf', label: 'UF', icon: icons.uf, align: 'center' },
    { key: 'nome_municipio', label: 'Município', icon: icons.municipio },
    { key: 'tipo_despesa', label: 'Tipo de Despesa', icon: icons.tipo },
    { key: 'descricao_conta', label: 'Conta', icon: icons.conta },
    { key: 'valor', label: 'Valor', icon: icons.valor, align: 'right', format: v => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }
];

const MunicipalAnnualExpense = () => (
    <DataPlataformListPage
        datasetKey="municipal-annual-expense"
        title="Despesa Anual dos Municípios"
        iconLeft={<img src="/images/icons/city.svg" width="18" alt="Municípios" />}
        label="MUNICÍPIOS"
        api={{
            search: `${process.env.REACT_APP_API_URL}/municipio-despesa`,
            grafico: `${process.env.REACT_APP_API_URL}/municipio-despesa-grafico`,
            exercicios: `${process.env.REACT_APP_API_URL}/municipio-despesa-exercicios`,
            contas: `${process.env.REACT_APP_API_URL}/municipio-despesa-filtro-conta`,
            ufs: `${process.env.REACT_APP_API_URL}/filtro-localidade`,
            email: `${process.env.REACT_APP_API_URL}/municipio-despesa-email`,
        }}
        columns={columns}
        enableTipoDespesaFilter
    />
);

export default MunicipalAnnualExpense;